import { useCallback, useEffect, useState } from "react";
import { trackEvent } from "@/lib/analytics";
import { storage } from "@/lib/storage";

const KEY = "atlas.favorites";
const EVENT = "atlas:favorites";
const isCode = (v) => typeof v === "string" && /^[A-Z]{2}$/.test(v);

const read = () => {
  const list = storage.getJSON(KEY, []);
  return Array.isArray(list) ? list.filter(isCode) : [];
};

export function useFavorites() {
  const [favorites, setFavorites] = useState(read);

  useEffect(() => {
    const sync = () => setFavorites(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener("storage", sync); };
  }, []);

  const toggle = useCallback((code) => {
    const current = read();
    const next = current.includes(code) ? current.filter((c) => c !== code) : [...current, code];
    storage.setJSON(KEY, next);
    trackEvent(current.includes(code) ? "unfavorite_country" : "favorite_country", { country_code: code });
    window.dispatchEvent(new Event(EVENT));
  }, []);

  const isFavorite = useCallback((code) => favorites.includes(code), [favorites]);
  return { favorites, toggle, isFavorite };
}
